import { isDueToday, isOverdue } from "./taskDates";

export { isDueToday, isOverdue };

export function computeTaskStats(tasks) {
    const active = tasks.filter((t) => t.status !== "Completed");
    const completed = tasks.filter((t) => t.status === "Completed");
    const dueToday = active.filter(isDueToday);
    const overdue = active.filter(isOverdue);
    const highPriority = active.filter((t) => t.priority?.toLowerCase() === "high");
    const paused = active.filter((t) => t.paused);

    return {
        total: tasks.length,
        active: active.length,
        completed: completed.length,
        dueToday: dueToday.length,
        overdue: overdue.length,
        highPriority: highPriority.length,
        paused: paused.length,
    };
}

export function groupTasksByAssignee(tasks, assignOptions = []) {
    const groups = new Map();

    const labelFor = (assignTo) => {
        const opt = assignOptions.find(
            (o) => String(o.value) === String(assignTo)
        );
        if (opt) return opt.label;
        return assignTo ? `Staff #${assignTo}` : "Unassigned";
    };

    tasks.forEach((task) => {
        const key = task.assign_to ?? "unassigned";
        if (!groups.has(key)) {
            const staff = task.staffuser;
            const name = staff
                ? `${staff.lastName || ""} ${staff.firstName || ""}`.trim()
                : labelFor(key);
            groups.set(key, {
                assignTo: key,
                name: name || labelFor(key),
                tasks: [],
                active: 0,
                overdue: 0,
                high: 0,
            });
        }
        const g = groups.get(key);
        g.tasks.push(task);
        if (task.status !== "Completed") {
            g.active += 1;
            if (isOverdue(task)) g.overdue += 1;
            if (task.priority?.toLowerCase() === "high") g.high += 1;
        }
    });

    return [...groups.values()].sort((a, b) => b.active - a.active);
}

export function statusBreakdown(tasks) {
    const counts = { Completed: 0, "In Progress": 0, Open: 0, Paused: 0 };
    tasks.forEach((t) => {
        if (t.paused && t.status !== "Completed") {
            counts.Paused += 1;
        } else if (t.status === "Completed") {
            counts.Completed += 1;
        } else if (t.status === "In Progress") {
            counts["In Progress"] += 1;
        } else {
            counts.Open += 1;
        }
    });
    return Object.entries(counts)
        .filter(([, v]) => v > 0)
        .map(([label, value]) => ({ label, value }));
}
